import * as React from 'react'
// libs
import styled from 'styled-components'
// icons
import CloseIconOrigin from '@mui/icons-material/Close'
// utils
import { size } from 'polished'

export const FieldsWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;

  & > div {
    flex: 1;
    margin-bottom: 8px;
  }
`

export const TitleWrapper = styled('div')`
  display: flex;
  gap: 12px;
  margin-right: 28px;

  & > div {
    flex: 1;
  }

  & > div :nth-child(2) {
    margin-right: 32px;
  }
`

export const CloseIcon = styled(({ iconSize, marginLeft, ...props }: any) => <CloseIconOrigin {...props} />)`
  && {
    cursor: pointer;
    margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : 'auto')};
    ${({ iconSize }) => size(`${iconSize ? iconSize : 20}px`)};
  }
`
